import script from "./Docs.vue?vue&type=script&setup=true&lang=js"
export * from "./Docs.vue?vue&type=script&setup=true&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=5b49d7b0&lang=css"

const __exports__ = script;

export default __exports__